var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 487.812 487.812",
    xmlSpace: "preserve",
    fill: "#ff8c08",
    stroke: "#ff8c08",
    strokeWidth: 19.512480000000004,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ff8c08"
    },
    d: "M474.585,189.821L261.86,32.94c-11.526-8.503-27.255-8.462-38.749,0.122L13.061,189.935 c-14.388,10.746-17.338,31.124-6.6,45.512c10.754,14.388,31.116,17.322,45.512,6.592l19.817-14.802v201.467 c0,17.956,14.558,32.514,32.514,32.514h276.534c17.972,0,32.514-14.558,32.514-32.514V225.457l22.638,16.696 c5.812,4.284,12.575,6.34,19.273,6.34c9.99,0,19.817-4.576,26.215-13.209C492.126,220.832,489.029,200.478,474.585,189.821z M348.73,400.88H136.81l-0.504-221.829l106.379-79.449l106.257,78.359L348.73,400.88z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ff8c08"
    },
    d: "M254.268,244.73c-21.142-8.746-24.711-13.258-24.711-20.078c0-6.243,4.633-12.916,17.639-12.916 c13.77,0,22.394,4.934,26.076,7.047c1.886,1.065,4.129,1.268,6.161,0.536c2.032-0.732,3.633-2.317,4.406-4.333l5.901-15.574 c1.26-3.365-0.081-7.153-3.178-8.974c-8.055-4.723-16.948-7.608-27.027-8.746v-16.03c0-4.072-3.292-7.373-7.373-7.373h-14.623 c-4.072,0-7.373,3.3-7.373,7.373v17.875c-21.85,5.836-35.636,22.549-35.636,43.951c0,26.938,22.045,39.22,43.537,47.65 c19.387,7.877,22.061,14.859,22.061,21.248c0,9.413-8.316,15.745-20.695,15.745c-10.356,0-21.533-3.316-29.897-8.901 c-1.886-1.26-4.251-1.561-6.405-0.862c-2.154,0.723-3.861,2.382-4.625,4.528l-5.657,15.794c-1.114,3.113-0.024,6.576,2.658,8.494 c8.072,5.763,20.484,9.949,33.018,11.299V359.4c0,4.072,3.3,7.373,7.373,7.373h14.867c4.081,0,7.373-3.3,7.373-7.373v-18.606 c22.532-6.08,37.278-23.939,37.278-46.048C295.399,265.279,273.403,252.533,254.268,244.73z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSale);
export default __webpack_public_path__ + "static/media/sale.3559e2d08cb2d7a1eb60debe4ba72078.svg";
export { ForwardRef as ReactComponent };